import 'src/styles/ui/radio.css';

import PropTypes from 'prop-types';
import React from 'react';

const Radio = ({ id, name, label, checked, onChange, disabled }) => {
  return (
    <label htmlFor={id} className={`radio ${disabled ? 'radio--disabled' : ''}`}>
      <input
        id={id}
        type='radio'
        className='radio__input'
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className='radio__checkmark'>
        <span className='radio__dot' />
      </span>
      {label}
    </label>
  );
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Radio.defaultProps = {
  label: '',
  checked: false,
  onChange: () => {},
};

export default Radio;
